/* eslint-disable no-console */
import React, { Fragment, useEffect, useState } from 'react';
// import { useStyles } from '../Reusable/Search/skills.style';
import { CommonButtonTypes } from 'Common/Types/Types';
// import twoColorBG from 'Assets/img/svg/Backgrounds/twoColorBg.svg';
import ClipLoader from 'react-spinners/ClipLoader';
// redux imports
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'ReduxStore/store';
// import { GetAllResources, GetResourceById } from 'ReduxStore/resources/Action';
// import { CustomSearchBox } from './AutoComplete';
// import { checkImage, goToLink, setImage } from 'Helpers';
import useMediaQuery from '@material-ui/core/useMediaQuery';
// import Pagination from '@material-ui/lab/Pagination';
// import ClipLoader from 'react-spinners/ClipLoader';
import EditIcon from '@material-ui/icons/Edit';
import Header from 'Components/Header/Header';
import { useParams } from 'react-router-dom';
import {
	changeExpiryAction,
	loadAllToyInstances,
	loadKidAddress,
	lookupKids,
	nextBoxAction,
	ShipToyAction,
} from 'ReduxStore/children/Action';
import { DataGrid, GridColDef, GridValueGetterParams } from '@material-ui/data-grid';
import Error from 'Components/Timeline/Error';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CustomModal from 'Components/Modals/CustomModal';
import ConditionalCard from 'Components/Reusable/Cards/ConditionalCard';
import moment from 'moment';
import { CommonButton } from 'Components/Reusable/Buttons/Buttons';
import { ReusableInput } from 'Components/Reusable/Inputs/ReusableInput';
import { PlainInput } from 'Components/Reusable/Inputs/PlainInput';
import { useStyles } from './Admin.style';
import { Grid, Paper, TableContainer, Typography } from '@material-ui/core';
import AdminHeader from 'Components/Header/AdminHeader';
import { Routes } from 'Utils';
interface SkillsProps extends CommonButtonTypes {
	width?: string;
}
interface paramI {
	id: string;
}
const Boxes = ({ common }: SkillsProps) => {
	const params = useParams<paramI>();
	const [open, setOpen] = useState(false);
	const [openBox, setOpenBox] = useState(false);
	const classes = useStyles({ common });
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const matches = useMediaQuery('(max-width:440px)');
	const errors = useSelector((state: RootState) => state.children.error);

	const [activeBox, setActiveBox] = useState<string>('');

	const [onChangeDateAction, setChangeDateAction] = useState(false);
	const [currentDate, setCurrentDate] = useState('');
	const [currentSub, setCurrentSub] = useState('');
	const changeDateAction = (currdate: any, id: any) => {
		setChangeDateAction(!onChangeDateAction);
		setCurrentDate(currdate);
		console.log(currdate);
		setCurrentSub(id);
	};
	useEffect(() => {
		setLoading(!loading);
		dispatch(lookupKids(params.id));
		dispatch(loadAllToyInstances(params.id));
		dispatch(loadKidAddress(params.id));
		setLoading(!loading);
	}, []);

	const lookUpKid = useSelector((state: RootState) => state?.children?.lookupKid);
	const address = useSelector((state: RootState) => state?.children?.address);
	console.log(address, 'my lookup kid obj');
	const allToys = useSelector((state: RootState) => state.children.allToyInstances);
	console.log(allToys && allToys[0], 'all my toys intances ');

	const onShipIntiate = (toyInstanceId: any) => {
		console.log(toyInstanceId);
		// dispatch(ShipToyAction(toyInstanceId));
		setActiveBox(toyInstanceId);
		setOpen(!open);
		// setTimeout(() => {
		// 	window.location.reload();
		// }, 1000);
	};

	const onDateChangeClick = (date: any) => {
		setCurrentDate(date);
		console.log('updated value is', date);
	};
	console.log('In parent', currentDate);
	const actionItems = () => {
		dispatch(ShipToyAction(activeBox));
		setActiveBox('');
		setTimeout(() => {
			window.location.reload();
		}, 1000);
	};
	const handleModalClick = (condition: any) => {
		condition === 'yes' ? actionItems() : setOpen(!open);
	};

	const moveToNextBoxAction = () => {
		console.log('I am clicked');
		setOpenBox(!openBox);
	};
	const nextActionEvents = () => {
		dispatch(nextBoxAction(params.id));
		setTimeout(() => {
			window.location.reload();
		}, 3000);
	};
	const moveToNextBox = (condition: any) => {
		// setOpenBox(!openBox);
		condition === 'yes' ? nextActionEvents() : setOpenBox(!openBox);
	};

	const checkLatestToy = () => {
		const latestToy = allToys && allToys[0];
		const today = moment.now();
		const diff = moment(latestToy && latestToy?.endDate).diff(today, 'days');
		console.log(diff);
		if (diff > 0) {
			return true;
		} else {
			if (lookUpKid && lookUpKid?.Subscriptions.length > 0) {
				console.log(lookUpKid && lookUpKid?.Subscriptions);
				const today = moment.now();
				const diff = moment(lookUpKid && lookUpKid?.Subscriptions[0].endDate).diff(today, 'days');
				if (diff >= 0 && lookUpKid && lookUpKid.Subscriptions[0].plan !== 'basic') {
					return true;
				}
				return false;
			}
			return false;
		}
	};
	checkLatestToy();
	const conditions = [
		{
			id: 1,
			name: 'no',
		},
		{
			id: 2,
			name: 'yes',
		},
	];

	const onSubmit = (e: any) => {
		e.preventDefault();
		if (currentDate) {
			//
			console.log('here', currentDate);
			const data = {
				subId: currentSub,
				expiryDate: currentDate,
			};
			dispatch(changeExpiryAction(data));

			console.log('dispatched');
			setChangeDateAction(!onChangeDateAction);
			window.location.reload();
		}
	};

	return (
		<Fragment>
			<AdminHeader />
			<section style={{ padding: '0.5rem' }} className="d-flex flex-column align-items-end flex-wrap">
				<ul className={`${classes.listItem} my-2`}>
					{lookUpKid ? (
						<section style={{ padding: '1rem' }}>
							<section style={{ display: 'flex', marginBottom: '1rem' }}>
								<CommonButton
									command="Back"
									common={{
										width: matches ? '100px' : '150px',
										height: '48px',
										background: '#7FD6DD',
										radius: '10px',
										color: 'white',
										// marginRight: '1rem',
									}}
									onClick={() => window.open(Routes.AdminHome, '_self')}
									// disabled={childId ? false : true}
								/>
							</section>
							<Typography className={classes.title} variant="h4">
								ChildId:
								<small className={classes.subTitle}>{lookUpKid?.id}</small>
							</Typography>

							{lookUpKid.Subscriptions &&
								lookUpKid.Subscriptions.map((subscription: any) => (
									<div key={subscription.id}>
										<Typography className={classes.title} variant="h4">
											Subscription Date:
											<small className={classes.subTitle}>
												{lookUpKid?.Subscriptions.length > 0 &&
													moment(subscription?.startDate).format('YYYY-MM-DD')}
											</small>
										</Typography>
									</div>
								))}

							<Typography className={classes.title} variant="h4">
								Parent Name:
								<small className={classes.subTitle}>{lookUpKid?.Parent.fullName}</small>
							</Typography>
							<Typography className={classes.title} style={{ overflowWrap: 'anywhere' }} variant="h4">
								Parent Email:
								<small className={classes.subTitle}>{lookUpKid?.Parent.email}</small>
							</Typography>
							<Typography className={classes.title} variant="h4">
								ChildName:
								<small className={classes.subTitle}>{lookUpKid?.fullName}</small>
							</Typography>
							<Typography className={classes.title} variant="h4">
								Child Gender:
								<small className={classes.subTitle}>{lookUpKid?.gender}</small>
							</Typography>
							<Typography className={classes.title} variant="h4">
								Child DoB:
								<small className={classes.subTitle}>
									{moment(lookUpKid?.dateOfBirth).format('YYYY-MM-DD')}
								</small>
							</Typography>
							{lookUpKid.Subscriptions &&
								lookUpKid.Subscriptions.map((subscription: any) => (
									<div key={subscription.id}>
										<section style={{ display: 'flex', flexDirection: 'row', rowGap: '4rem' }}>
											<Typography className={classes.title} style={{ marginRight: '1rem' }} variant="h4">
												Membership expiry date:
												<small className={classes.subTitle}>
													{moment(subscription.endDate).format('MMMM Do YYYY')}
												</small>
											</Typography>
											<button className={classes.clickButton}>
												<EditIcon onClick={() => changeDateAction(subscription.endDate, subscription.id)} />
											</button>
										</section>

										<Typography className={classes.title} variant="h4">
											Subscription:
											<small className={classes.subTitle}>{subscription.plan}</small>
										</Typography>
									</div>
								))}
							{address && (
								<section style={{ marginTop: '1rem', marginBottom: '1rem' }}>
									<Typography className={classes.title} style={{ fontSize: '25px' }} variant="h4">
										Shipment
									</Typography>

									<Typography className={classes.title} variant="h4">
										Name:
										<small className={classes.subTitle}>{lookUpKid?.Parent.fullName}</small>
									</Typography>

									<Typography className={classes.title} variant="h4">
										City :
										<small className={classes.subTitle}>
											{address.shipping_city ? address.shipping_city : address.city}
										</small>
									</Typography>

									<Typography className={classes.title} variant="h4">
										State :
										<small className={classes.subTitle}>
											{address.shipping_state ? address.shipping_state : address.state}
										</small>
									</Typography>
									<Typography className={classes.title} variant="h4">
										Zip :
										<small className={classes.subTitle}>
											{address.shipping_zipCode ? address.shipping_zipCode : address.zipCode}
										</small>
									</Typography>
									<Typography className={classes.title} variant="h4">
										Address :
										<small className={classes.subTitle}>
											{address.shipping_address ? address.shipping_address : address.address}
										</small>
									</Typography>
								</section>
							)}

							<section
								style={{
									display: 'flex',
									flexDirection: 'row',
									rowGap: '3rem',
									marginBottom: '1rem',
									marginTop: '1rem',
								}}
							>
								<Typography
									className={classes.title}
									style={{ marginTop: '1rem', marginLeft: '1rem' }}
									variant="h4"
								>
									Boxes:
								</Typography>
								<div></div>
								{checkLatestToy() && (
									<button
										className={classes.clickButton}
										style={{ marginRight: '1rem' }}
										onClick={moveToNextBoxAction}
									>
										<Typography
											// className={classes.subTitle}
											style={{
												fontSize: '18px',
												fontFamily: 'Poppins',
												// marginLeft: '1rem',
												fontWeight: 'normal',
											}}
											// className={classes.title}
											// style={{ marginTop: '1rem' }}
											variant="h4"
										>
											move to next box
										</Typography>
									</button>
								)}
							</section>

							{allToys && allToys?.length > 0 && (
								<TableContainer className={classes.table} component={Paper}>
									<Table aria-label="simple table" className={classes.table}>
										<TableHead>
											<TableRow>
												<TableCell> Box ID</TableCell>
												<TableCell align="right">Box Start Date</TableCell>
												<TableCell align="right">Box Expiry date</TableCell>
												<TableCell align="right">Box number</TableCell>
												<TableCell align="right">Box name</TableCell>
												<TableCell align="right">Shipping Date</TableCell>
												<TableCell align="right">Ship status </TableCell>
												<TableCell align="right"></TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{allToys?.map(item => (
												// <div key={item.id}></div>
												<TableRow key={item.id}>
													<TableCell component="th" scope="row">
														{item.id}
													</TableCell>
													<TableCell align="right">{moment(item.startDate).format('YYYY-MM-DD')}</TableCell>
													<TableCell align="right">{moment(item.endDate).format('YYYY-MM-DD')}</TableCell>
													<TableCell align="right">{item.Toy.id}</TableCell>
													<TableCell align="right">{item.Toy.name}</TableCell>
													<TableCell align="right">
														{item.shippingDate ? moment(item.shippingDate).format('YYYY-MM-DD') : '--'}
													</TableCell>
													<TableCell align="right">
														{item.shipped === true ? 'Shipped' : 'Not Shipped'}
													</TableCell>
													{/* <TableCell align="right" onClick={() => onShipIntiate(item.id)}>
														Ship
													</TableCell> */}
													{/* #TODO handle this later */}
													{item.shipped === true ? (
														<TableCell align="center">Already Shipped</TableCell>
													) : (
														<TableCell align="center" onClick={() => onShipIntiate(item.id)}>
															<button className={classes.clickButton} style={{ padding: '1rem' }}>
																Ship
															</button>
														</TableCell>
													)}
												</TableRow>
											))}
										</TableBody>
									</Table>
								</TableContainer>
							)}
						</section>
					) : (
						<div className={classes.loading}>
							{errors ? (
								<Error errors={errors} />
							) : (
								<div className={classes.loading}>
									<h4>Wait a moment ...</h4>
									<ClipLoader color={'#7FD6DD'} loading={true} size={50} />
								</div>
							)}
						</div>
					)}
				</ul>
				{open ? (
					<CustomModal open={open}>
						<ConditionalCard
							information="Are you sure you want to ship this Box now?"
							heading={`Alert!`}
							conditions={conditions}
							// image={ clickedLink === Routes.MilestoneCategories ? MilestoneImage : Activity}
							onClick={handleModalClick}
						></ConditionalCard>
					</CustomModal>
				) : (
					''
				)}
				{openBox ? (
					<CustomModal open={openBox}>
						<ConditionalCard
							information="Are you sure you want to move to the next Box now?"
							heading={`Alert!`}
							conditions={conditions}
							// image={ clickedLink === Routes.MilestoneCategories ? MilestoneImage : Activity}
							onClick={moveToNextBox}
						></ConditionalCard>
					</CustomModal>
				) : (
					''
				)}

				{onChangeDateAction ? (
					<CustomModal open={onChangeDateAction}>
						<div className={classes.addChildModal}>
							<form onSubmit={onSubmit}>
								<ul className={`${classes.listItems} text-center`}>
									<li>
										{/* <input type="date" /> */}
										<PlainInput
											label="date"
											name="date"
											type="date"
											placeholder="date"
											defaultValue={moment(currentDate).format('YYYY-MM-DD')}
											// formik={formik}
											width={matches ? '250px' : '381.87px'}
											height="53.91px"
											onChange={onDateChangeClick}
										/>
									</li>
								</ul>

								<div className="mx-auto d-flex flex-column justify-content-center align-items-center mb-5">
									<CommonButton
										common={{
											background: '#7FD6DD',
											radius: '5px',
										}}
										command={loading ? 'SAVE' : <ClipLoader color={'white'} loading={true} size={30} />}
									/>
								</div>
							</form>
						</div>
					</CustomModal>
				) : (
					''
				)}
			</section>
			{/* </div> */}
		</Fragment>
	);
};

export default Boxes;
